module.exports = __webpack_public_path__ + "static/img/img-qrcode.d7f3643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-qrcode.png
// module id = KCgx
// module chunks = 1